import React, { useCallback, useEffect, useRef, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { addAciveClass, nowDate, checkCorporateRegiNumber, phoneFormat, bizNumFormat } from '../../tools'
import { NoticePopup, ApplyAccount, ApplyPcContent, ErrorPopup, Footer, ServiceList, Spinner, SuccessPopup, TermsPopup } from '../../common'
import { useNavigate, useParams } from 'react-router-dom'
import { applyConfig, commonConfig } from '../../configs'
import html2canvas from 'html2canvas'

const Account = () => {
  const param = useParams()
  const formRef = useRef()

  const [selectList, setSelectList] = useState({
    bank_code: [{ name: '은행 선택', value: '' }]
  })

  useEffect(() => {
    getBankCode()
    getAccountModiShopInfo()

    // getIsIos()
    // checkBrowser()
  }, [])

  // input[type="number"] 마우스 휠 블러 처리
  useEffect(() => {
    document.addEventListener('mousewheel', function () {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur()
      }
    })
  }, [])

  // 아이폰인지 확인
  const getIsIos = () => {
    console.log('getIsIos')
    const checkUserAgent = navigator.userAgent.toLowerCase()
    console.log(checkUserAgent)

    if (checkUserAgent.indexOf('iphone') != -1 || checkUserAgent.indexOf('ipad') != -1) {
      setIsIos(true)
    }
  }

  function isBrowserCheck() {
    const agt = navigator.userAgent.toLowerCase()
    if (agt.indexOf('chrome') != -1) return 'Chrome'
    if (agt.indexOf('opera') != -1) return 'Opera'
    if (agt.indexOf('staroffice') != -1) return 'Star Office'
    if (agt.indexOf('webtv') != -1) return 'WebTV'
    if (agt.indexOf('beonex') != -1) return 'Beonex'
    if (agt.indexOf('chimera') != -1) return 'Chimera'
    if (agt.indexOf('netpositive') != -1) return 'NetPositive'
    if (agt.indexOf('phoenix') != -1) return 'Phoenix'
    if (agt.indexOf('firefox') != -1) return 'Firefox'
    if (agt.indexOf('safari') != -1) return 'Safari'
    if (agt.indexOf('skipstone') != -1) return 'SkipStone'
    if (agt.indexOf('netscape') != -1) return 'Netscape'
    if (agt.indexOf('mozilla/5.0') != -1) return 'Mozilla'
    if (agt.indexOf('msie') != -1) {
      let rv = -1
      if (navigator.appName == 'Microsoft Internet Explorer') {
        let ua = navigator.userAgent
        var re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})')
        if (re.exec(ua) != null) rv = parseFloat(RegExp.$1)
      }
      return 'Internet Explorer ' + rv
    }
  }

  function checkBrowser() {
    const browser = isBrowserCheck()
    if (browser === 'Safari') {
      setIsIos(true)
    }
  }

  /** 은행목록 셀렉터 확인  */
  const getBankCode = useCallback((item, SetManagerName) => {
    const data = { parent_code: 'bank_code' }
    commonConfig
      .getCodeList(data)
      .then(result => {
        setSelectList({
          bank_code: [...selectList.bank_code, ...selectItemFormat(result.data, 'code_name', 'code')]
        })
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  const [detailInfo, setDetailInfo] = useState()

  const navi = useNavigate()
  // 상세정보 가져오기
  const getAccountModiShopInfo = () => {
    const data = {
      shop_code: param.shop_code
    }
    applyConfig
      .getModiShopInfo(data)
      .then(result => {
        setDetailInfo(result)
        console.log(result)
        // 여기서 정보 입력
        setValue('biz_no', result.biz_no)
        setValue('shop_name', result.shop_name)
        setValue('owner_name', result.owner_name)
        setValue('owner_phone_no', result.owner_phone_no)

        setValue('different_customer_name', result.owner_name)
        setValue('apply_phone_no', result.owner_phone_no)
        setOwnerName(result.owner_name)
        setOwnerPhoneNoName(result.owner_phone_no)
        setValue('bank_code', result.bank_code)

        setValue('account_name', result.account_name)
        setValue('apply_name', result.account_name)
        setValue('account_phone_no', result.account_phone_no)
        setValue('account_no', result.account_no)
        setValue('account_jumin_biz_no', result.account_jumin_biz_no)
        setValue('id', result.id)
        setValue('password', result.password)
      })
      .catch(error => {
        console.log(error)
        alert(error.message)
        navi('/')
      })
  }

  const different_customer_sign_ref = useRef(null)
  const different_account_sign_ref = useRef(null)
  const [isIos, setIsIos] = useState(false)
  const [successPopupState, setSuccessPopupState] = useState(false) // 성공 팝업 상태
  const [errorPopupState, setErrorPopupState] = useState(false) // 실패 팝업 상태
  const [errorPopupMessage, setErrorPopupMessage] = useState() // 실패 팝업 메세지

  //헤더 스크롤
  const [mainScrollPosition, setMainScrollPosition] = useState(0)
  const updateScroll = () => {
    setMainScrollPosition(document.querySelector('.application_sheet').scrollTop)
  }

  //캔버스 서명 글씨
  const [differentCustomerIsSigned, setDifferentCustomerIsSigned] = useState(false)
  const [differentAccountIsSigned, setDifferentAccountIsSigned] = useState(false)

  //서명 헬퍼
  const [applyCheck, setApplyCheck] = useState()
  const [accountCheck, setAccountCheck] = useState()

  //신청서 유효성 검사
  const formSchema = yup.object({
    biz_no: yup //사업자 정보
      .string()
      .required('필수정보입니다.')
      .min(10, '사업자번호 10자를 입력해주세요.')
      .max(10, '10자가 넘었습니다 사업자번호 10자를 입력해주세요.')
      .matches(/^[0-9]+$/, '숫자만 입력해주세요.'),
    shop_name: yup.string().required(),
    owner_name: yup.string().required(),
    owner_phone_no: yup
      .string()
      .required('필수정보입니다.')
      .min(10, '전화번호 10~11자를 입력해주세요.')
      .max(11, '전화번호 10~11자를 입력해주세요.')
      .matches(/^[0-9]+$/, '숫자만 입력해주세요.'),
    account_name: yup.string().required(), //계좌 출금 정보
    account_phone_no: yup
      .string()
      .required('필수정보입니다.')
      .min(10, '전화번호 10~11자를 입력해주세요.')
      .max(11, '전화번호 10~11자를 입력해주세요.')
      .matches(/^[0-9]+$/, '숫자만 입력해주세요.'),
    account_no: yup
      .string()
      .required('필수정보입니다.')
      .matches(/^[0-9]+$/, '숫자만 입력해주세요.'),
    account_jumin_biz_no: yup
      .string()
      .required('필수정보입니다.')
      .test({
        test(value, ctx) {
          if (value.length === 6 || value.length === 10) {
            return true
          } else {
            return ctx.createError({ message: '6자 또는 10자를 입력해주세요.' })
          }
        }
      })
      .matches(/^[0-9]+$/, '숫자만 입력해주세요.'),

    //신청자 확인 및 약관 동의
    apply_phone_no: yup
      .string()
      .min(10, '전화번호 10~11자를 입력해주세요.')
      .max(11, '전화번호 10~11자를 입력해주세요.')
      .matches(/^[0-9]+$/, '숫자만 입력해주세요.'),

    apply_name: yup.string(),
    account_relation: yup.string(),
    agree_yn: yup.boolean().required('필수정보입니다.').oneOf([true], '필수정보입니다.'),
    bank_code: yup.string().required('필수정보입니다.'),
    different_apply_customer: yup.string().required()
  })

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(formSchema),

    defaultValues: {
      biz_no: '',
      shop_name: '',
      owner_name: '',
      owner_phone_no: '',
      account_name: '',
      account_phone_no: '',
      bank_code: '',
      account_no: '',
      account_jumin_biz_no: '',
      different_customer_name: '',
      apply_phone_no: ''
    }
  })

  /** 계좌변경 신청  */
  const setApplyUpdt = useCallback(data => {
    applyConfig
      .setApplyUpdt(data)
      .then(result => {
        setSuccessPopupState(true)
      })
      .catch(error => {
        setErrorPopupMessage(error.message)
        setErrorPopupState(true)
        console.log(error)
      })
  }, [])

  const onSubmit = async item => {
    // 사업자번호 체크 (사업자번호, 예금주 사업자번호)
    if (checkCorporateRegiNumber(item?.biz_no) === false) return alert('사업자등록번호를 확인해주세요')

    if (item?.account_jumin_biz_no.length === 10 && checkCorporateRegiNumber(item?.biz_no) === false) return alert('예금주 사업자번호를 확인해주세요')

    // 신청자와 대표자가 다르다에 체크했는데 서명안했을때
    const diff_apply_value_check = getValues('different_apply_customer')
    if (!differentCustomerIsSigned) {
      let location = document.querySelector('#apply_check').offsetTop
      const wrap = document.querySelector('.application_sheet')
      wrap.scrollTo({ top: location - 100, behavior: 'smooth' })
      setApplyCheck('서명을 해주세요.')
      return
    }

    // 예금주가 다르다에 체크했는데 서명안했을때
    const diff_account_value_check = getValues('different_account')
    if (diff_account_value_check && !differentAccountIsSigned) {
      let location = document.querySelector('#account_check').offsetTop
      const wrap = document.querySelector('.application_sheet')
      wrap.scrollTo({ top: location - 100, behavior: 'smooth' })
      setAccountCheck('서명을 해주세요.')
      return
    }

    // const el = document.getElementById('application_sheet_id')
    const el = document.getElementById('capture_area')
    const canvas = await html2canvas(el, {
      scale: 2,
      allowTaint: true,
      useCORS: true,
      imageTimeout: 10000,

      onclone: document => {
        // document.getElementById('application_sheet_id').style.height = '100%'
      }
    })

    // console.log('스샷 이미지 확인')
    // document.querySelector('body').append(canvas)

    let apply_name
    if (item?.different_apply_customer) {
      apply_name = item?.different_customer_name
    } else {
      apply_name = item?.apply_name
    }
    let bank_neme = selectList.bank_code.filter(data => data.value === item?.bank_code)
    const data = {
      biz_no: item?.biz_no.replace(/-/g, '') || '', //사업자등록번호
      shop_name: item?.shop_name || '', //사업자명
      owner_name: item?.owner_name || '', //대표자명
      owner_phone_no: item?.owner_phone_no || '', //대표자휴대폰
      bank_code: item?.bank_code || '', //은행코드
      bank_name: bank_neme[0]?.name || '', //은행이름
      account_name: item?.account_name || '', //예금주명
      account_phone_no: item?.account_phone_no || '', //예금주 휴대폰
      account_no: item?.account_no || '', //계좌번호
      account_jumin_biz_no: item?.account_jumin_biz_no || '', //예금주 생년월일/사업자번호
      agree_yn: item?.agree_yn === true ? 'Y' : 'N' || '', //약관동의여부
      apply_name: apply_name || '', //신청자명
      apply_phone_no: item?.apply_phone_no || '', //신청자 휴대폰
      account_relation: item?.account_relation || '', //예금주와의 관계
      apply_file: canvas.toDataURL('image/jpeg') || '',
      shop_token: param?.shop_code || '',
      shop_idx: detailInfo?.shop_idx,
      payment_idx: detailInfo?.payment_idx
    }
    setApplyUpdt(data)
  }

  const [ownerName, setOwnerName] = useState()
  const [ownerPhoneNo, setOwnerPhoneNoName] = useState()
  const [accountName, setAccountName] = useState()
  const ownerNameSetting = e => {
    setValue('different_customer_name', e.target.value)
    setOwnerName(e.target.value)
  }
  const ownerPhoneNoSetting = e => {
    setValue('apply_phone_no', e.target.value)
    setOwnerPhoneNoName(e.target.value)
  }
  const accountNameSetting = e => {
    setValue('apply_name', e.target.value)
    setAccountName(e.target.value)
  }

  //체크박스 체크 여부
  const [diffApplyCustomerCheck, setDiffApplyCustomerCheck] = useState(true)
  const differentApplyCustomerCheck = e => {
    setDiffApplyCustomerCheck(!e.target.checked)
    if (e.target.checked) {
      setValue('different_customer_name', '')
      setValue('apply_phone_no', '')
    } else {
      setValue('different_customer_name', ownerName)
      setValue('apply_phone_no', ownerPhoneNo)
    }
  }
  const [diffAccountCheck, setDiffAccountCheck] = useState(true)
  const differentAccountCheck = e => {
    if (e.target.checked === true) {
      e.target.parentNode.parentNode.classList.add('isOpen')
    } else {
      e.target.parentNode.parentNode.classList.remove('isOpen')
    }
    setDiffAccountCheck(!e.target.checked)
  }

  //약관 팝업 닫기
  function termsPopupClose(e) {
    if (e.target.className === 'btn_close') {
      //닫기 버튼 누른 경우
      document.querySelector('.application_sheet').scrollTop = 1900
      document.querySelector('.terms_popup').classList.remove('open')
    } else {
      //동의 하기 버튼 누른 경우
      setValue('agree_yn', true)
      document.querySelector('.application_sheet').scrollTop = 1900
      document.querySelector('.terms_popup').classList.remove('open')
      // document.querySelector('.application_sheet').classList.remove('notScroll')
    }
  }

  return (
    <div className="Application SubPages">
      <div className="application_wrap">
        <ApplyPcContent /> {/* 1024 이상 display */}
        <div
          id="application_sheet_id"
          className={successPopupState || errorPopupState ? 'application_sheet notScroll' : 'application_sheet 2'}
          onScroll={updateScroll}
          ref={formRef}>
          <div className={mainScrollPosition < 276 ? 'main_wrap' : 'main_wrap scroll'}>
            <div className="header">
              <div className="logo_brg"></div>
              <div className="env_state">{process.env.REACT_APP_NODE_ENV === 'development' ? '[개발서버]' : ''}</div>
            </div>
            <h1 id="main_text_wrap">
              스폰지R <br /> 출금계좌 변경 신청서
            </h1>
            <p className="main_subtit">스폰지R 서비스는 소중한 고객이 작성한 배달앱 리뷰를 위탁 관리하는 서비스입니다.</p>
          </div>
          <form className="application_form_wrap" onSubmit={handleSubmit(onSubmit)} id="capture_area">
            <div id="capture_area_0">
              <div className="customer_wrap">
                <p className="wrap_tit">
                  사업자 정보<span className="color_r">*</span>
                </p>
                <div className="customer_box">
                  <label htmlFor="biz_no">사업자 등록번호</label>
                  <div className="pull-right">{bizNumFormat(detailInfo?.biz_no)}</div>
                  <input
                    type="hidden"
                    name="biz_no"
                    id="biz_no"
                    {...register('biz_no')}
                    className={errors.biz_no ? 'error' : ''}
                    autoComplete="off"
                  />
                </div>
                <div className="customer_box">
                  <label htmlFor="shop_name">사업자명</label>
                  <div className="pull-right">{detailInfo?.shop_name}</div>
                  <input
                    type="hidden"
                    name="shop_name"
                    id="shop_name"
                    {...register('shop_name')}
                    className={errors.shop_name ? 'error' : ''}
                    autoComplete="off"
                  />
                </div>
                <div className="customer_box">
                  <label htmlFor="owner_name">대표자명</label>
                  <div className="pull-right">{detailInfo?.owner_name}</div>
                  <input
                    type="hidden"
                    name="owner_name"
                    id="owner_name"
                    autoComplete="off"
                    {...register('owner_name', { onChange: ownerNameSetting })}
                    className={errors.owner_name ? 'error' : ''}
                  />
                </div>
                <div className="customer_box">
                  <label htmlFor="owner_phone_no">대표자 휴대폰</label>
                  <div className="pull-right">{phoneFormat(detailInfo?.owner_phone_no)}</div>
                  <input
                    autoComplete="off"
                    type="hidden"
                    name="owner_phone_no"
                    id="owner_phone_no"
                    {...register('owner_phone_no', { onChange: ownerPhoneNoSetting })}
                    className={errors.owner_phone_no ? 'error' : ''}
                  />

                  <p className="caution">{errors.owner_phone_no && errors.owner_phone_no.message}</p>
                </div>
              </div>
              <div className="bank_account_wrap">
                <p className="wrap_tit">
                  계좌 출금 정보<span className="color_r">*</span>
                </p>
                <div className="bank_account_box">
                  <label htmlFor="account_name">예금주명</label>
                  <input
                    autoComplete="off"
                    type="text"
                    name="account_name"
                    id="account_name"
                    {...register('account_name', { onChange: accountNameSetting })}
                    className={errors.account_name ? 'error' : ''}
                  />
                  <p className="caution">예&#41; 홍길동</p>
                </div>

                <div className="bank_account_box">
                  <label htmlFor="account_phone_no">예금주 휴대폰</label>
                  <input
                    type="number"
                    name="account_phone_no"
                    id="account_phone_no"
                    autoComplete="off"
                    {...register('account_phone_no')}
                    className={errors.account_phone_no ? 'error' : ''}
                  />
                  <p className="caution">{errors.account_phone_no && errors.account_phone_no.message}</p>
                </div>

                <div className="bank_account_box">
                  <label htmlFor="bank_code">은행</label>
                  <select name="bank_code" id="bank_code" {...register('bank_code')} className={errors.bank_code ? 'error' : ''}>
                    {selectList.bank_code.map(item => (
                      <option value={item.value} key={item.value}>
                        {item.name}
                      </option>
                    ))}
                  </select>

                  <p className="caution">{errors.bank_code && errors.bank_code.message}</p>
                </div>

                <div className="bank_account_box">
                  <label htmlFor="account_no">계좌번호</label>
                  <input
                    type="text"
                    name="account_no"
                    id="account_no"
                    autoComplete="off"
                    {...register('account_no')}
                    className={errors.account_no ? 'error' : ''}
                  />
                  <p className="caution">{errors.account_no && errors.account_no.message}</p>
                </div>

                <div className="bank_account_box">
                  <label htmlFor="account_jumin_biz_no">예금주 생년월일(6자리) / 사업자번호(10자리)</label>
                  <input
                    type="text"
                    name="account_jumin_biz_no"
                    id="account_jumin_biz_no"
                    autoComplete="off"
                    {...register('account_jumin_biz_no')}
                    className={errors.account_jumin_biz_no ? 'error' : ''}
                  />

                  <p className="caution">{errors.account_jumin_biz_no && errors.account_jumin_biz_no.message}</p>
                  <div className="color_r m_t_10 explain_text">
                    "예금주가 개인, 개인사업자 통장인 경우 생년월일을 입력해주세요"
                    <br />
                    "예금주가 법인 사업자 통장인 경우 사업자번호를 입력해주세요"
                  </div>
                </div>

                <div className="bank_account_box bank_account_info">
                  <p className="bank_account_info_tit">서비스 비용 출금 정보</p>
                  <ul>
                    <li>&#183; 서비스 이용 비용 출금은 매월 1일~13일 출금됩니다.</li>
                    <li>&#183; 지속적으로 미출금시 서비스 이용이 제한됩니다.</li>
                  </ul>
                </div>
              </div>

              <div className="terms_wrap">
                <p className="wrap_tit">
                  신청자 확인 및 약관 동의
                  <span className="color_r">*</span>
                </p>
                <div className="terms_box" id="apply_check">
                  <div className="terms_check">
                    <input
                      type="checkbox"
                      name="different_apply_customer"
                      id="different_apply_customer"
                      autoComplete="off"
                      {...register('different_apply_customer', { onChange: differentApplyCustomerCheck })}
                    />
                    <label htmlFor="different_apply_customer">
                      <em></em>대표자와 신청자가 다른 경우 체크
                    </label>
                  </div>
                  <div className="terms_sign">
                    <label htmlFor="different_customer_name">신청자</label>
                    <input
                      type="text"
                      name="different_customer_name"
                      id="different_customer_name"
                      {...register('different_customer_name')}
                      readOnly={diffApplyCustomerCheck}
                      className={errors.different_customer_name ? 'error' : ''}
                    />
                    <label htmlFor="apply_phone_no">신청자 휴대폰</label>
                    <input
                      type="number"
                      name="apply_phone_no"
                      id="apply_phone_no"
                      readOnly={diffApplyCustomerCheck}
                      autoComplete="off"
                      {...register('apply_phone_no')}
                    />

                    <p className="caution">{errors.apply_phone_no && errors.apply_phone_no.message}</p>

                    <p className="terms_agree_date" dangerouslySetInnerHTML={{ __html: nowDate() }}></p>
                    <div className="sign">
                      <p className={differentCustomerIsSigned ? 'sign_placeholder blind' : 'sign_placeholder'}>서명</p>
                      <SignatureCanvas
                        clearOnResize={false}
                        id="different_customer_sign"
                        ref={different_customer_sign_ref}
                        canvasProps={{
                          className: 'signature_canvas'
                        }}
                        onBegin={() => {
                          setDifferentCustomerIsSigned(true)
                        }}
                      />
                      <button
                        className="sign_reset_btn"
                        type="button"
                        onClick={() => {
                          different_customer_sign_ref.current.clear() // 리셋
                          setDifferentCustomerIsSigned(false)
                        }}></button>
                    </div>
                    {<div className="color_r m_t_10">{applyCheck}</div>}
                  </div>
                </div>
                <div className="terms_box diffrent_account" id="account_check">
                  <div className="terms_check">
                    <input
                      type="checkbox"
                      name="different_customer"
                      id="different_account"
                      autoComplete="off"
                      {...register('different_account')}
                      onClick={differentAccountCheck}
                    />
                    <label htmlFor="different_account">
                      <em></em> 신청자와 예금주가 다른 경우 체크
                    </label>
                  </div>
                  <div className="terms_sign">
                    <label htmlFor="apply_name">예금주</label>
                    <input
                      type="text"
                      name="apply_name"
                      id="apply_name"
                      readOnly={true}
                      autoComplete="off"
                      {...register('apply_name')}
                      className={errors.apply_name ? 'error' : ''}
                    />

                    <label htmlFor="account_relation">신청자와의 관계</label>
                    <input
                      type="text"
                      name="account_relation"
                      id="account_relation"
                      autoComplete="off"
                      {...register('account_relation')}
                      className={errors.account_relation ? 'error' : ''}
                    />

                    <p className="terms_agree_date" dangerouslySetInnerHTML={{ __html: nowDate() }}></p>
                    <div className="sign">
                      <p className={differentAccountIsSigned ? 'sign_placeholder blind' : 'sign_placeholder'}>서명</p>
                      <SignatureCanvas
                        clearOnResize={false}
                        ref={different_account_sign_ref}
                        id="different_account_sign"
                        canvasProps={{
                          className: 'signature_canvas'
                        }}
                        onBegin={() => {
                          setDifferentAccountIsSigned(true)
                        }}
                      />
                      <button
                        className="sign_reset_btn"
                        type="button"
                        onClick={() => {
                          different_account_sign_ref?.current?.clear?.() // 리셋
                          setDifferentAccountIsSigned(false)
                        }}></button>
                    </div>
                    {<div className="color_r m_t_10">{accountCheck}</div>}
                  </div>
                </div>
                <div className={errors.agree_yn ? 'terms_box error' : 'terms_box'}>
                  <div className="terms_check">
                    <input
                      type="checkbox"
                      name="agree_yn"
                      id="agree_yn"
                      autoComplete="off"
                      {...register('agree_yn')}
                      className={errors.agree_yn ? 'error' : ''}
                    />
                    <label htmlFor="agree_yn">
                      <em></em> 개인정보 및 고유식별정보 수집 및 이용 동의
                    </label>
                    <p className="terms_open" onClick={termsPopupOpen}></p>
                  </div>
                </div>
                <p className="caution w_100">{errors.agree_yn && errors.agree_yn.message}</p>
              </div>
            </div>

            <div className="submit_wrap">
              <p>
                본 서비스 신청과 관련하여 서비스 내용, 출금 정보, 이용 약관을 충분히 숙지하고, 하이픈코퍼레이션 CMS 자동이체를 신청하기 위해 금융거래
                정보 제공 및 개인정보의 수집, 이용, 개인정보 제3자 제공에 동의하며. 이에 본 서비스를 신청합니다.
              </p>
              <button type="submit" className="btn_default">
                출금 등록/변경 신청하기
              </button>
            </div>
          </form>
          {/* 푸터내용 */}
          <Footer />

          {/* 약관 성공 팝업 TODO 캡쳐 파라미터 미사용, 삭제해야함 */}
          <TermsPopup termsPopupClose={termsPopupClose} capture={false} />

          {/* 신청 성공 팝업 */}
          <ApplyAccount open={successPopupState} />

          {/* 신청 성공 팝업 */}
          <NoticePopup open={isIos} />

          {/* 신청 오류 팝업 */}
          <ErrorPopup open={errorPopupState} setErrorPopupState={setErrorPopupState} errorPopupMessage={errorPopupMessage} />
        </div>
      </div>
    </div>
  )
}

export { Account }

//약관 팝업 열기
function termsPopupOpen() {
  document.querySelector('.terms_popup').classList.add('open')
  document.querySelector('.application_sheet').scrollTop = 0
}

const selectItemFormat = (data, name, value) => {
  return data.map(item => {
    return {
      name: item[name]?.replaceAll('\r', '')?.replaceAll('\n', ''),
      value: typeof item[value] === 'string' ? item[value]?.replaceAll('\r', '')?.replaceAll('\n', '') : item[value]
    }
  })
}

export { ApplyAccount }
